export var LegalDocument;
(function (LegalDocument) {
    LegalDocument["PROCESSING_CONTRACT"] = "processing-contract";
    LegalDocument["PRIVACY_POLICY"] = "privacy-policy";
    LegalDocument["PRIVACY_POLICY_PREVENTION"] = "privacy-policy-prevention";
    LegalDocument["TERMS_OF_USE_OFFICE_USER"] = "terms-of-use-office-user";
    LegalDocument["TERMS_OF_USE_PATIENT"] = "terms-of-use-patient";
    LegalDocument["TERMS_OF_USE_PREVENTION"] = "terms-of-use-prevention";
    LegalDocument["CONSENT_DECLERATION"] = "consent-decleration";
    /**
     * Subprozessor-Hinweis for the KI-Dokumentation (Spec § 8). Confirmed once
     * per practice by an Office-ADMIN; the confirmed version and the SHA-256 of
     * its rendered HTML are recorded on `pt_ai_documentation_activation`.
     */
    LegalDocument["AI_DOCUMENTATION_NOTICE"] = "ai-documentation-notice";
})(LegalDocument || (LegalDocument = {}));
//# sourceMappingURL=legal-document.enum.js.map